import React from 'react'
import logo from '../../../assets/static/logo-citral.png'

const LogotipoCitral = () => <img src={logo} alt="Logotipo Citral" />

export default LogotipoCitral
